const autocompleteModalFilterEquip = {
  groups: 'Group',
  place: 'Local',
  area: 'Departments',
  company: 'Third party company',
  equipmentModel: 'Equipment Type',
  site: 'Sites',
  status: 'Status'
};

export default autocompleteModalFilterEquip;
